import { ApiResponse } from "../Types";
import {
  CourierAssignmentFilters,
  CourierAssignmentFormData,
  CourierFormData,
} from "../Types/CourierTypes";
import { axiosClientv1 } from "./apiClient";

export const getCouriers = async (): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/couriers");
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load couriers.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const saveCourier = async (
  data: CourierFormData,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/couriers/save", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save courier.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const deleteCourier = async (
  id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/couriers/delete", { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete courier.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const assignCourierToOrder = async (
  data: CourierAssignmentFormData,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/couriers/assign", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to assign courier.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const updateCourierAssignmentStatus = async (data: {
  assignment_id: string;
  status: string;
  notes?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/couriers/update-status", data);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to update courier status.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const getCourierAssignments = async (
  filters: CourierAssignmentFilters = {},
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get("/couriers/assignments", {
      params: filters,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Failed to load courier assignments.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const unassignCourier = async (
  assignment_id: string,
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post("/couriers/unassign", {
      assignment_id,
    });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to unassign courier.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};
